import React, { Suspense, memo, useEffect, useRef, useState } from 'react'
import { MathUtils, Vector3 } from "three"
import { Canvas, useFrame } from '@react-three/fiber'
import { OrbitControls, Environment, GradientTexture, AccumulativeShadows, RandomizedLight, Lightformer } from '@react-three/drei';
import { Pds } from "../../r3f/pds"
import { useInView } from 'react-intersection-observer'
import "./logo.css"
// Logo3D
function Logo3D(props) {
  // const { data } = props
  const rendererContainer = useRef()
  // const [hovered, ] = useState(false)

  // Horizon lower than base to show off some of the cool sky and sun
  // const horizon = 0


  // Set base parameters baby
  const [orbitControls, ] = useState(false)
  const [cameraSelect, ] = useState('start')

  // Prepped camera positions
  const cameraSelects = {
    start: {
      position: new Vector3( 0, 15, 11 ),
      target: new Vector3( 0, 0, 0 ),
      zoom: 18,
      speed: 0.5
    },
  }


    
  // Camera rigs
  const refOrbitControls = useRef()

  useEffect(() => {
    if (refOrbitControls.current) {
      refOrbitControls.current.enablePan = orbitControls
      refOrbitControls.current.enableRotate = orbitControls
      refOrbitControls.current.enableZoom = orbitControls
    }
  },[orbitControls])

  function CameraRig() {
    // console.log('Rendered CameraRig')

    let zoom = refOrbitControls.current?.object?.zoom ? refOrbitControls.current.object.zoom : 80

    useFrame(({ pointer }, delta) => {
      // console.log(refOrbitControls.current)
      // console.log(delta)
      if (!orbitControls) {

        // // Camera Pan
        const x = pointer.x * 0.01
        const y = pointer.y * 0.005
        refOrbitControls.current.object.translateX(x)
        refOrbitControls.current.object.translateY(y)

        // Camera FOV Lerp
        zoom = MathUtils.lerp(zoom, cameraSelects[cameraSelect].zoom, 0.01)
        refOrbitControls.current.object.zoom = zoom

        // Camera Position Lerp
        refOrbitControls.current.object.position.lerp(cameraSelects[cameraSelect].position, 0.01)
        // Camera Target Lerp
        refOrbitControls.current.target.lerp(cameraSelects[cameraSelect].target, 0.02)

        // Update the camera matrix so all above applies right
        refOrbitControls.current.object.updateProjectionMatrix()

      }

    })
  }

  const { ref, inView } = useInView()

  return (
    <div className={"logo-box"}>
      <section ref={ref} id="home-footer" className="section-3d">
        <a href="https://pdshospitality.com/" target="_blank" rel="noreferrer noopener" ref={rendererContainer} id="renderer-container-footer" className='c3 kawabun-home'>
          {/* With key date refresh hack */}
          <Canvas frameloop={inView ? 'always' : 'never'} dpr={[1,2]} flat={true} linear={false} orthographic shadows camera={{ position: [-5, 35, 6], target: [5,5,-1], zoom: 80, near: 0.01, far: 1000 }} gl={{ preserveDrawingBuffer: true }}>
            {/* Preferrably <Loadeer/> instead of null but it gets a warning */}
            <Suspense fallback={null}>

              <OrbitControls
                ref={refOrbitControls}
                makeDefault
                enabled={true}
                autoRotate={true}
                dampingFactor={0.05}
                enablePan={false} // by default turn off
                enableRotate={false} // by default turn off
                enableZoom={false} // by default turn off
              />
              <CameraRig />



              <Pds />

              <Environment resolution={32}>
                <group rotation={[-Math.PI / 4, -0.3, 0]}>
                  <Lightformer intensity={15} rotation-x={Math.PI / 2} position={[-5, 12, 4]} scale={[50, 50, 1]} />
                  {/* <Lightformer intensity={1} rotation-y={-Math.PI / 2} position={[-20, 1, 0]} scale={[20, 20, 1]} /> */}
                  <Lightformer type="ring" intensity={2} rotation-y={Math.PI / 2} position={[20, -1, -5]} scale={30} />
                  {/* <Lightformer intensity={2} rotation-x={-Math.PI / 2} position={[0, 15, -20]} scale={[40, 40, 1]} /> */}
                </group>
              </Environment>

              <Shadows />


              <GradientTexture attach="background" stops={[0, 1]} colors={['#BEAD80', '#FCFBF5']} />



            </Suspense>

          </Canvas>
          
        </a>
        
        <div id="vertexShader" type="vertex">

        </div>
        <div id="fragmentShader" type="fragment">

        </div>

      </section>
    </div>
  )
}

export default Logo3D

const Shadows = memo(() => (
  <AccumulativeShadows temporal={false} frames={300} blend={300} limit={300} opacity={1} color="#958761" colorBlend={0.5} alphaTest={0.14} scale={50} resolution={1024}>
    <RandomizedLight amount={4} radius={10} ambient={0.5} intensity={1} position={[0, 30, -30]} size={25} mapSize={1024} bias={0.0001} />
  </AccumulativeShadows>
))
